import {
    IMG_URL,
    NEW_LIST,
} from './mutation-types'

export default {
    [IMG_URL](state,imgUrl){
        state.imgUrl = imgUrl;
    },
    [NEW_LIST](state,newList){
        state.newList = newList;
    },
}


// WEBPACK FOOTER //
// ./src/store/mutations.js